module.exports = __webpack_public_path__ + "b39a5513bfc0470520de36d41fb61cc0.jpg";